import { render } from "./PaymentReceiptCreateTopSection.vue?vue&type=template&id=21bf9fb0&scoped=true"
import script from "./PaymentReceiptCreateTopSection.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptCreateTopSection.vue?vue&type=script&lang=js"

import "./PaymentReceiptCreateTopSection.vue?vue&type=style&index=0&id=21bf9fb0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21bf9fb0"]])

export default __exports__